import Store from '@/store';
import ComissoesClient from '@/api/relatorios/comissoes.client';
import { ErrorMessage } from '@/libs/Error';
import Notifier from '@/libs/Notifier';

export default class ComissoesService {
  constructor() {
    this.client = new ComissoesClient();
    this.error = new ErrorMessage();
    this.notify = new Notifier();
    this.store = Store;
  }

  async findAll(params = {}) {
    try {
      const response = await this.client.findAll(params);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar dados do relatório de comissões');
      throw error;
    }
  }

  async gerarPdfComissoes(params = {}) {
    try {
      const response = await this.client.gerarPdfComissoes(params);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao gerar PDF do relatório de comissões');
      throw error;
    }
  }
}
